import router from './router'
import store from './store'
import { Message } from 'element-ui'

const whiteList = ['/login']

router.beforeEach(async (to, from, next) => {
  const hasToken = store.getters.token
  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      Message.warning('请先登录')
      next('/login?redirect=' + encodeURIComponent(to.fullPath))
    }
  }
})
